export default "__VITE_ASSET__Ds3y5VGs__"